export const downloadBlob = (blob: Blob, filename: string) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => {
    window.URL.revokeObjectURL(url);
  }, 0);
};

export const downloadText = (
  content: string,
  filename: string,
  mimeType = 'text/plain;charset=utf-8;'
) => {
  const blob = new Blob([content], { type: mimeType });
  downloadBlob(blob, filename);
};
